import React from 'react';
import { IconListItem } from '../../types';
import PageTitle from '../../components/PageTitle';
import IconList from '../../components/IconList';

type MentalsIndexProps = {
    favoritesItem: IconListItem | null,
    mentals: Array<IconListItem>,
}

const MentalsIndexPage = ({ mentals, favoritesItem }: MentalsIndexProps) => {
    let listItems: Array<IconListItem>;

    if (favoritesItem) {
        listItems = [
            favoritesItem,
            ...mentals,
        ];
    } else {
        listItems = mentals;
    }

    return (
        <>
            <PageTitle documentTitleParts={['Unsere Mentals']}>
                Hallo bei
                <strong>eleMental</strong>
            </PageTitle>
            <IconList items={listItems} />
        </>
    );
};

export default MentalsIndexPage;
